import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBG_CUSTOM_06_Schema } from './M_TBG_CUSTOM_06_Schema';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

/** TBM 참석인원 조회 GetTbmR4 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_TBG_CUSTOM_06_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.TBM.getTbmR4, params);
  }, successOptions);
};

/** 동영상/TBM_CD 조회 GetTbmR2 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_TBG_CUSTOM_06_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.TBM.getTbmR2, params);
  }, successOptions);
};

/** 교육현황 저장 SaveTbmStatusU1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_06_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.TBM.saveTbmStatusU1, payload);
  }, options);
};
